"use strict";
/*
 * Created on 15. 1. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");

var ExportedPriceListRow_1 = require("./ExportedPriceListRow");
/**
 * Represents single price list row in {@link PriceList price list} exported to CSV.
 *
 * @author Radek Beran
 */


var CSVExportedPriceListRow =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(CSVExportedPriceListRow, _DomainObject_1$Domai);

  /**
   * Constructs price list row exported to CSV.
   * @param id internal id
   * @param changeType
   * @param priceListExternalId
   * @param dateFrom
   * @param dateTo
   * @param productExternalId includes both productId and salesVariantId parts, but exported product_id will contain only productId part
   * @param salesVariantId
   * @param price
   * @param vatTypeId
   * @param externalPriceCode
   * @param sequenceId
   */
  function CSVExportedPriceListRow(id, changeType, priceListExternalId, dateFrom, dateTo, productExternalId, salesVariantId, price, vatTypeId, externalPriceCode, sequenceId) {
    var _this;

    _classCallCheck(this, CSVExportedPriceListRow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CSVExportedPriceListRow).call(this));
    _this.id = id;
    _this.changeType = changeType;
    _this.priceListExternalId = priceListExternalId;
    _this.dateFrom = dateFrom;
    _this.dateTo = dateTo;
    _this.productExternalId = productExternalId;
    _this.salesVariantId = salesVariantId;
    _this.price = price;
    _this.vatTypeId = vatTypeId;
    _this.externalPriceCode = externalPriceCode;
    _this.sequenceId = sequenceId;
    return _this;
  }
  /**
   * Creates new instance from given document.
   */


  _createClass(CSVExportedPriceListRow, null, [{
    key: "fromDocument",
    value: function fromDocument(source, conversions) {
      return new CSVExportedPriceListRow(ExportedPriceListRow_1.ExportedPriceListRow.schema.id.valueOf(conversions.documentToClassId(source)), ExportedPriceListRow_1.ExportedPriceListRow.schema.changeType.valueOfField(source), ExportedPriceListRow_1.ExportedPriceListRow.schema.priceListExternalId.valueOfField(source), ExportedPriceListRow_1.ExportedPriceListRow.schema.dateFrom.valueOfField(source), ExportedPriceListRow_1.ExportedPriceListRow.schema.dateTo.valueOfField(source), ExportedPriceListRow_1.ExportedPriceListRow.schema.productExternalId.valueOfField(source), ExportedPriceListRow_1.ExportedPriceListRow.schema.salesVariantId.valueOfField(source), ExportedPriceListRow_1.ExportedPriceListRow.schema.price.valueOf(conversions.toBigNumber(source.price)), ExportedPriceListRow_1.ExportedPriceListRow.schema.vatTypeId.valueOfField(source), ExportedPriceListRow_1.ExportedPriceListRow.schema.externalPriceCode.valueOfField(source), ExportedPriceListRow_1.ExportedPriceListRow.schema.sequenceId.valueOfField(source));
    }
  }]);

  return CSVExportedPriceListRow;
}(DomainObject_1.DomainObject);

exports.CSVExportedPriceListRow = CSVExportedPriceListRow;